export const GET_AWARD = 'GET_AWARD';
export const GET_AWARD_SUCCESS = 'GET_AWARD_SUCCESS';

export const GET_AWARDS = 'GET_AWARDS';
export const GET_AWARDS_SUCCESS = 'GET_AWARDS_SUCCESS';

export const GET_MY_AWARD_ENTRY = 'GET_MY_AWARD_ENTRY';
export const GET_MY_AWARD_ENTRY_SUCCESS = 'GET_MY_AWARD_ENTRY_SUCCESS';

export const GET_AWARD_ENTRY = 'GET_AWARD_ENTRY';
export const GET_AWARD_ENTRY_SUCCESS = 'GET_AWARD_ENTRY_SUCCESS';

export const REGISTER_AWARD = 'REGISTER_AWARD';
export const REGISTER_AWARD_SUCCESS = 'REGISTER_AWARD_SUCCESS';
export const REGISTER_AWARD_FAILED = 'REGISTER_AWARD_FAILED';

export const VOTING_AWARD = 'VOTING_AWARD';
export const VOTING_AWARD_SUCCESS = 'VOTING_AWARD_SUCCESS';
export const VOTING_AWARD_FAILED = 'VOTING_AWARD_FAILED';

export const CHECK_VOTED = 'CHECK_VOTED';
export const CHECK_VOTED_SUCCESS = 'CHECK_VOTED_SUCCESS';
export const CHECK_VOTED_FAILED = 'CHECK_VOTED_FAILED';

export const DELETE_AWARD_ENTRY = 'DELETE_AWARD_ENTRY';
export const DELETE_AWARD_ENTRY_SUCCESS = 'DELETE_AWARD_ENTRY_SUCCESS';
export const DELETE_AWARD_ENTRY_FAILED = 'DELETE_AWARD_ENTRY_FAILED';

export const RESET_FORM_REGISTER = 'RESET_FORM_REGISTER';
